import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

// @ts-ignore
import { ReactComponent as CloseIcon } from '../../../assets/images/close-icon.svg';

// @ts-ignore
import './ReconciliationSuccessDialog.scss';

interface ReconciliationSuccessDialogProps {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void> | void;
    bagId?: string | null;
}

const ReconciliationSuccessDialog: React.FC<ReconciliationSuccessDialogProps> = ({
    visible,
    onHide,
    onConfirm,
    bagId,
}) => {
    const { t, i18n } = useTranslation();
    const [inProgress, setInProgress] = useState(false);
    const bagNumber = bagId ?? '';

    useEffect(() => {
        if (!visible) {
            setInProgress(false);
        }
    }, [visible]);

    const rawQuestion = i18n.getResource(
        i18n.language,
        'translation',
        'cashoperations.confirmReconciliationQuestion',
    );

    const question = rawQuestion
        ? rawQuestion.replace('{bagNumber}', bagNumber)
        : `Would you like to confirm the reconciliation of bag №${bagNumber}?`;

    const handleConfirm = async () => {
        try {
            setInProgress(true);
            await onConfirm();
        } catch (error) {
            console.error('ReconciliationSuccessDialog onConfirm error:', error);
        } finally {
            setInProgress(false);
        }
    };

    const handleHide = () => {
        if (inProgress) return;
        onHide();
    };

    return (
        <Dialog
            visible={visible}
            onHide={handleHide}
            header={null}
            className="reconciliation-success-dialog"
            closable={!inProgress}
            closeIcon={<CloseIcon />}
            modal
            draggable={false}
            resizable={false}
            appendTo={document.body}
            style={{ width: '540px' }}
        >
            <div className="reconciliation-success-container">
                <div className="reconciliation-success-text-container">
                    <h2 className="reconciliation-success-title">
                        {t(
                            'cashoperations.amountRegisteredSuccessfully',
                            'The entered amount has been registered successfully.',
                        )}
                    </h2>

                    <div className="reconciliation-success-description">
                        <p>
                            {t(
                                'cashoperations.amountRegisteredMessage',
                                'The entered amount has been registered successfully.',
                            )}
                        </p>

                        <p>{question}</p>
                    </div>
                </div>

                <div className="reconciliation-success-buttons">
                    <button
                        type="button"
                        className="reconciliation-success-button-primary"
                        onClick={handleConfirm}
                        disabled={inProgress}
                    >
                        {inProgress ? (
                            <span className="reconciliation-success-loading-label">
                                <i className="pi pi-spinner pi-spin" />
                                {t('common.loading', 'Loading...')}
                            </span>
                        ) : (
                            t('cashoperations.ok', 'Ok')
                        )}
                    </button>

                    <button
                        type="button"
                        className="reconciliation-success-button-secondary"
                        onClick={handleHide}
                        disabled={inProgress}
                    >
                        {t('cashoperations.cancel', 'Cancel')}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default ReconciliationSuccessDialog;